// Remembers the last used organization identifier (tenant slug) across
// sessions so users don't have to re-enter it after logging out.
// The logout page (/clear) preserves this key when wiping localStorage;
// clicking "Change organization" on the login form forgets it.

export const REMEMBERED_ORG_STORAGE_KEY = "lastOrgSlug";

export function getRememberedOrgSlug(): string | null {
  try {
    return localStorage.getItem(REMEMBERED_ORG_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function rememberOrgSlug(slug: string): void {
  try {
    localStorage.setItem(REMEMBERED_ORG_STORAGE_KEY, slug);
  } catch {
    // Storage unavailable (e.g. blocked); remembering is best-effort
  }
}

export function forgetOrgSlug(): void {
  try {
    localStorage.removeItem(REMEMBERED_ORG_STORAGE_KEY);
  } catch {
    // Storage unavailable (e.g. blocked); forgetting is best-effort
  }
}
